import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import MobileMenu from '../MobileMenu/MobileMenu'
import { connect } from "react-redux";
import { removeFromCart } from "../../store/actions/action";

const Header = (props) => {
    const location = useLocation();

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }

    // Check if parent menu "Our Team" should be active
    const isTeamParentActive = () => location.pathname.startsWith("/team");

    const activeStyle = {
        color: "#e10303",
        fontWeight: 600,
        //backgroundColor: "rgba(0,123,255,0.1)",
        borderRadius: "4px",
        transition: "color 0.3s, background-color 0.3s"
    }

    const activeStyleNeutral = {
        //color: "#000000",
        fontWeight: 600,
        //backgroundColor: "rgba(0,123,255,0.1)",
        borderRadius: "4px",
        transition: "color 0.3s, background-color 0.3s"
    }

    return (
        <header id="header" className={`site-header ${props.hclass}`}>
            <nav className="navigation navbar navbar-expand-lg navbar-light">
                <div className="container-fluid">
                    <div className="navbar-header">
                        <MobileMenu />
                        <NavLink
                            onClick={scrollToTop}
                            className="navbar-brand"
                            to="/home"
                            style={{ display: "inline-block" }}
                        >
                            <img src={props.Logo} alt="" />
                        </NavLink>
                    </div>

                    <div id="navbar" className="collapse navbar-collapse navigation-holder">
                        <button className="close-navbar"><i className="ti-close"></i></button>

                        <ul className="nav navbar-nav mb-2 mb-lg-0">
                            <li className="menu-item-has-children">
                                <NavLink
                                    to="/"
                                    end
                                    onClick={scrollToTop}
                                    style={({ isActive }) => isActive ? activeStyle : activeStyleNeutral}
                                >
                                    Home
                                </NavLink>
                            </li>

                            <li className="menu-item-has-children">
                                <NavLink
                                    to="/causes"
                                    onClick={scrollToTop}
                                    style={({ isActive }) => isActive ? activeStyle : activeStyleNeutral}
                                >
                                    Causes
                                </NavLink>
                            </li>

                            <li>
                                <NavLink
                                    to="/events"
                                    onClick={scrollToTop}
                                    style={({ isActive }) => isActive ? activeStyle : activeStyleNeutral}
                                >
                                    Events
                                </NavLink>
                            </li>

                            <li className={`menu-item-has-children ${isTeamParentActive() ? "active" : ""}`}>
                                <NavLink
                                    to="/team"
                                    onClick={scrollToTop}
                                    style={isTeamParentActive() ? activeStyle : activeStyleNeutral}
                                >
                                    Our Team
                                </NavLink>
                                <ul className="sub-menu">
                                    <li>
                                        <NavLink
                                            to="/team"
                                            onClick={scrollToTop}
                                            style={({ isActive }) => isActive ? activeStyle : activeStyleNeutral}
                                        >
                                            Team
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink
                                            to="/team-single/Liza-Hart"
                                            onClick={scrollToTop}
                                            style={({ isActive }) => isActive ? activeStyle : activeStyleNeutral}
                                        >
                                            Our Founder
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>

                            <li>
                                <NavLink
                                    to="/about"
                                    onClick={scrollToTop}
                                    style={({ isActive }) => isActive ? activeStyle : activeStyleNeutral}
                                >
                                    About Us
                                </NavLink>
                            </li>

                            <li>
                                <NavLink
                                    to="/contact"
                                    onClick={scrollToTop}
                                    style={({ isActive }) => isActive ? activeStyle : activeStyleNeutral}
                                >
                                    Contact Us
                                </NavLink>
                            </li>
                        </ul>
                    </div>

                    <div className="cart-search-contact">
                        <div className="donate-btn">
                            <NavLink
                                to="/cause-single/Childrens-voices"
                                className={props.btnClass}
                                onClick={scrollToTop}
                                style={({ isActive }) => isActive ? {...activeStyle, padding: "6px 12px"} : undefined}
                            >
                                <i className="fi flaticon-like"></i> Donate Now
                            </NavLink>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    )
}

const mapStateToProps = (state) => ({
    carts: state.cartList.cart,
});

export default connect(mapStateToProps, { removeFromCart })(Header);
